import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../routeNames';
import data from '../projects/data.json';
import { useUi } from '../context/UiContext';
import { t } from '../i18n';
import Seo from '../components/Seo';
import { trackEvent } from '../analytics';
import { FiGithub, FiExternalLink, FiGlobe, FiTwitter, FiLinkedin, FiYoutube, FiBook, FiShoppingBag } from 'react-icons/fi';
import { SiKickstarter, SiAmazon } from 'react-icons/si';

function getLinkIcon(href, type) {
  const url = String(href || '').toLowerCase();
  // explicit type overrides
  if (type === 'github') return <FiGithub />;
  if (type === 'website') return <FiGlobe />;
  if (type === 'twitter') return <FiTwitter />;
  if (type === 'linkedin') return <FiLinkedin />;
  if (type === 'youtube') return <FiYoutube />;
  if (type === 'kickstarter') return <SiKickstarter />;
  if (type === 'book') return <FiBook />;
  if (type === 'product') return <FiShoppingBag />;

  // heuristics by URL
  if (url.includes('github.com')) return <FiGithub />;
  if (url.includes('kickstarter.com')) return <SiKickstarter />;
  if (url.includes('amazon.')) return <SiAmazon />;
  if (url.includes('goodreads.com') || url.includes('books.google') || url.includes('bookshop.org') || url.includes('leanpub.com')) return <FiBook />;
  if (url.includes('twitter.com') || url.includes('x.com')) return <FiTwitter />;
  if (url.includes('linkedin.com')) return <FiLinkedin />;
  if (url.includes('youtube.com') || url.includes('youtu.be')) return <FiYoutube />;
  if (url.includes('/dp/') || url.includes('/product/')) return <FiShoppingBag />;
  if (url.startsWith('http')) return <FiGlobe />;
  return <FiExternalLink />;
}

function ProjectCard({ project, showProgress }) {
  return (
    <Link to={routes.project(project.slug)} className="card" style={{ textDecoration: 'none' }} onClick={() => trackEvent('view_project', { slug: project.slug })}>
      <div>
        {project.image ? (
          <img className="card-media" src={project.image} alt={project.title} />
        ) : (
          <div className="card-media" />
        )}
        <div className="card-body gray-gradient-element">
          <h3 className="card-title">{project.title}</h3>
          <p className="card-desc">{project.description}</p>
          {Array.isArray(project.links) && project.links.length > 0 && (
            <div className="link-row">
              {project.links.map((l, idx) => (
                <a
                  key={idx}
                  href={l.href}
                  target="_blank"
                  rel="noreferrer"
                  className="link-icon"
                  aria-label={l.label || l.href}
                  onClick={(e) => { e.stopPropagation(); trackEvent('project_link_click', { slug: project.slug, href: l.href }); }}
                >
                  {getLinkIcon(l.href, l.type)}
                </a>
              ))}
            </div>
          )}
        </div>
        {showProgress && (
          <div className="progress-bar" style={{ width: `${project.progress || 0}%` }} />
        )}
      </div>
    </Link>
  );
}

export default function Projects() {
  const current = data.current || [];
  const previous = data.previous || [];
  const { lang } = useUi();

  return (
    <div style={{ paddingTop: 32, paddingBottom: 32 }}>
      <Seo title={t(lang, 'projects.title')} description={t(lang, 'projects.current')} />
      <h2 className="section-title">{t(lang, 'projects.current')}</h2>
      <div className="grid">
        {current.map(p => (
          <ProjectCard key={p.slug} project={p} showProgress={true} />
        ))}
      </div>

      <h2 className="section-title">{t(lang, 'projects.previous')}</h2>
      <div className="grid">
        {previous.map(p => (
          <ProjectCard key={p.slug} project={p} showProgress={false} />
        ))}
      </div>
    </div>
  );
}


